import * as React from "react";
const SvgDragHandleOutlined = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
    <path fill="none" d="M0 0h24v24H0z" />
    <path d="M20 9H4v2h16V9zM4 15h16v-2H4v2z" />
  </svg>
);
export default SvgDragHandleOutlined;
